import { render, staticRenderFns } from "./Keywords.vue?vue&type=template&id=30aba520&scoped=true"
import script from "./Keywords.vue?vue&type=script&lang=js"
export * from "./Keywords.vue?vue&type=script&lang=js"
import style0 from "./Keywords.vue?vue&type=style&index=0&id=30aba520&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30aba520",
  null
  
)

export default component.exports